/** @jsx jsx */
import { h, FunctionalComponent, Fragment } from 'preact'
import { useEffect, useState } from 'preact/hooks'
import { css, jsx } from '@emotion/core'

import Icon from '../../ui/Icon/IconFactory'
import { getDefaultRankStylesObj } from './rank.styles'
import { TeamObject } from '../../types/props'
import { useSiteVars } from '../../themes/useSiteVars'

interface RankProps {
    rank: string | null
    rankType: 'player' | 'team'
    team: TeamObject
    name?: string
    metaA?: string
    metaB?: string
    linkUrlA?: string
    linkLabelA?: string
    linkUrlB?: string
    linkLabelB?: string
    innerContent?: string
    preview?: boolean
    url?: string
}
const Rank: FunctionalComponent<RankProps> = (props) => {
    const siteVars = useSiteVars()
    const RankStyles = getDefaultRankStylesObj(siteVars, props.preview)
    const [data, setData] = useState<RankProps>({
        rank: '',
        rankType: 'player',
        name: '',
        team: {
            name: '',
            logoUrl: '',
            id: 0,
            sport: '',
            league: '',
            division: '',
            shortName: '',
        },
        metaA: '',
        metaB: '',
        linkUrlA: '',
        linkLabelA: '',
        linkUrlB: '',
        linkLabelB: '',
        innerContent: '',
        url: props.url,
    })
    const {
        rank,
        rankType,
        name,
        team: teamRaw,
        metaA,
        metaB,
        linkUrlA,
        linkLabelA,
        linkUrlB,
        linkLabelB,
        innerContent,
        url,
    } = data
    let team = teamRaw
    if (typeof teamRaw === 'string') {
        team = JSON.parse(teamRaw)
    }

    const getembed = async () => {
        try {
            if (!url) {
                throw new Error('URL is required')
            }
            const response = await fetch(url)
            const { data } = await response.json()
            setData(data)
        } catch (error) {
            setData(props)
            return { posts: [], property: '' }
        }
    }
    useEffect(() => {
        if (url) {
            getembed()
        }
    }, [url])
    const metaText = metaA || metaB

    return (
        <Fragment>
            <div css={RankStyles.root}>
                <div
                    css={css`
                        ${RankStyles.contentWrapper} ${!metaText && RankStyles.center}
                    `}
                >
                    {rank && (
                        <div css={RankStyles.headerIcon}>
                            <Icon icon="GradeBacker" fill="#999" />
                            <span>{rank}</span>
                        </div>
                    )}
                    <div css={RankStyles.headerWrapper}>
                        <h2 css={RankStyles.header}>{rankType === 'player' ? name : team.name}</h2>
                        {metaText && (
                            <div css={RankStyles.metaText}>
                                {metaA && <span>{metaA}</span>}
                                {metaA && metaB && <span css={RankStyles.divider}> | </span>}
                                {metaB && <span>{metaB}</span>}
                            </div>
                        )}
                    </div>
                    <div css={RankStyles.logo}>
                        <img src={team.logoUrl} alt={`${team.name} Logo`} />
                    </div>
                </div>
                {linkUrlA && (
                    <div css={RankStyles.buttonContainer}>
                        <a
                            href={linkUrlA}
                            css={css`
                                ${RankStyles.button} ${RankStyles.first}
                            `}
                            target="_top"
                        >
                            {linkLabelA}
                        </a>
                        {linkUrlB && (
                            <a
                                href={linkUrlB}
                                css={css`
                                    ${RankStyles.button} ${RankStyles.second}
                                `}
                                target="_top"
                            >
                                {linkLabelB}
                            </a>
                        )}
                    </div>
                )}
            </div>
            {innerContent && (
                <div
                    css={RankStyles.innerContent}
                    // eslint-disable-next-line
                    dangerouslySetInnerHTML={{ __html: innerContent }}
                />
            )}
        </Fragment>
    )
}

export default Rank
